module.exports = __webpack_public_path__ + "img/bank-line-trans.b9412af0.svg";